import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { BarChart3, FileText, Settings, LogOut, Home, Database, BookOpen, KeyRound, GraduationCap } from 'lucide-react';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const { user, logout } = useAuthStore();

  const isActive = (path: string) => location.pathname === path;

  const navItems = [
    { path: '/', label: 'Dashboard', icon: Home },
    { path: '/data', label: 'Data Viewer', icon: Database },
    { path: '/logs', label: 'System Logs', icon: FileText },
    { path: '/settings', label: 'Settings', icon: Settings },
    { path: '/api-docs', label: 'API Docs', icon: BookOpen },
    { path: '/users', label: 'API Users', icon: KeyRound },
    { path: '/tutorials', label: 'Tutorials', icon: GraduationCap },
  ];

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="logo">
            <BarChart3 className="icon" />
            <span>iView Admin</span>
          </div>
        </div>

        <nav className="nav-menu">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
              >
                <Icon className="icon" size={20} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{user?.email.charAt(0).toUpperCase()}</div>
            <div>
              <div className="user-name">{user?.email}</div>
              <div className="user-role">{user?.role}</div>
            </div>
          </div>
          <button className="logout-btn" onClick={logout}>
            <LogOut size={16} />
            Logout
          </button>
        </div>
      </aside>

      <main className="main-content">
        <header className="header">
          <h1>iView Assistant Admin Panel</h1>
        </header>
        <div className="content">{children}</div>
      </main>
    </div>
  );
}
